export default __webpack_public_path__ + "static/media/5_grunge_god.c808eb37.png";